import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMatch } from 'lodash';
import reduxTabs from './reduxTabs';
import TabList from './TabList';
import TabContent from './TabContent';
import tabIdentity from './helpers/tabIdentity';
import analyticsPage from '../../../analyticsPage';

class Tabs extends Component {
  constructor(props, context) {
    super(props, context);

    this.bindTab = ::this.bindTab;
  }

  // TODO refactor this.
  // Hardcoded scenario, but should be defined as configurable parameters
  // Or it should be defined as callback function
  bindTab(tab) {
    return React.cloneElement(tab, {
      active: isMatch(tabIdentity(tab.props), this.props.activeTab),
      handleTabClick: () => {
        const tabCanBeActivated = (
          tab.props.canActivate && tab.props.canActivate({ userServices: this.props.userServices })
        ) || !tab.props.canActivate;
        if (tabCanBeActivated) {
          this.props.handleTabClick(tabIdentity(tab.props));
          analyticsPage();
        } else {
          const redirectURL = tab.props.redirectTo || '/subscriptions';
          global.location.assign(redirectURL);
        }
      },
    });
  }

  renderTabList() {
    const [tabList] = this.props.children;
    const { headerComponent: HeaderComponent } = this.props;

    const TabListComponent = (
      <TabList>
        {React.Children.map(tabList.props.children, this.bindTab)}
      </TabList>
    );

    const TabHeaderComponent = (
      <HeaderComponent
        title={this.props.activeTab.heading}
        email={this.props.email}
      >
        {TabListComponent}
      </HeaderComponent>
    );

    return (
      HeaderComponent ? TabHeaderComponent : TabListComponent
    );
  }

  renderContent() {
    const [, tabContent] = this.props.children;
    return (
      <TabContent>
        {tabContent.props.children[this.props.activeTabIndex]}
      </TabContent>
    );
  }

  // TabHeader accepts active tab
  // TabHeader accepts logged in user email
  // wrap TabList Helper
  render() {
    return (
      <div className="tabsContainer">
        {
        [
          this.renderTabList(),
          this.renderContent(),
        ]
        }
      </div>
    );
  }
}

function getActiveTab(state) {
  return state.router.location.pathname + state.router.location.hash;
}

// Try to find out more elegant way to pass email into tabs component
function mapStateToProps(state) {
  return {
    userServices: state.userServices,
    email: state.userInfo.data !== null ? state.userInfo.data.email : '',
  };
}

export default connect(mapStateToProps)(reduxTabs({
  tabs: 'myAccount',
}, getActiveTab)(Tabs));
